import React, { useEffect } from 'react';
import { AppShell } from 'components/Layout/AppShell';
import { BREAKPOINTS } from 'constants/breakpoints';
import useMediaQuery from 'hooks/useMediaQuery';
import useSideMenuStore from 'store/useSideMenuStore';

export type IMenuWrapperProps = {
  children: React.ReactNode;
};

/**
 * App chrome entry point. Shell layout lives in Layout/AppShell.
 * Drawer open state is forced closed at md+ so legacy store toggles don't stick.
 */
export function MainLayout({ children }: IMenuWrapperProps) {
  const isMdUp = useMediaQuery(`(min-width: ${BREAKPOINTS.md}px)`);
  const hideSideMenu = useSideMenuStore(s => s.hide);

  useEffect(() => {
    if (isMdUp) {
      hideSideMenu();
    }
  }, [isMdUp, hideSideMenu]);

  return <AppShell>{children}</AppShell>;
}
